import {createElement, PropTypes} from 'rlink-react';
import {FluxStoreBoundComponent} from 'rlink-flux';
import shopStore from 'rlink-shop/store';
import {deepEquals} from 'rlink-utils/object';
import {ContentImg} from 'rlink-repos/content-components';

import Region from 'rlink-regions/Region';
import ShopProvider from 'rlink-shop/service/base';

import ShopItemBackgroundImage from 'rlink-shop/components/ShopItemBackgroundImage';
import MoreInfoButton from 'rlink-shop/components/MoreInfoButton';
import BuyButton from 'rlink-shop/components/BuyButton';
import ShopItemStatus from 'rlink-shop/components/ShopItemStatus';
import ShopItemFootnote from 'rlink-shop/components/ShopItemFootnote';
import ShopItemTitle from 'rlink-shop/components/ShopItemTitle';
import MoreInfoModal from 'rlink-shop/components/MoreInfoModal';
import BuildContext from 'rlink-router/BuildContext';


export default class ShopItem extends FluxStoreBoundComponent {

  //@TODO move back to componentWillMount if we can pre-fetch store data during rendering somehow
  componentDidMount () {
    super.componentDidMount();
    if (typeof this.props.service !== 'undefined') {
      let onContentLoad = () => {
        this.setState({ showLoader: false });
      };
      this.props.service.loadProduct(this.props.shopItem.identifier, this.props.shopItem.purchaseIdentifier, this.props.purchaseModalSize, onContentLoad, this.props.userCountry);
      this.checkAndLoadShopItemModal(this.props);
    }
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.open !== nextProps.open) {
      this.checkAndLoadShopItemModal(nextProps);
    }
  }

  checkAndLoadShopItemModal (props) {
    if (props.open) {
      let productData = this.getStateFromStore();
      let modalContent = <MoreInfoModal
        css={props.css}
        productData={productData}
        service={props.service}
        shopItem={props.shopItem}
        ratingsBoard={this.ratingsBoard(props)}
        onSale={this.onSale()} />;
      props.onOpenInfoModal(this.context.buildContext, modalContent);
    }
  }

  ratingsBoard (props) {
    if (props.region
      && 'ratingsBoards' in props.shopItem) {
      let defaultRatingsBoard = props.defaultRatingsBoard;
      let ratingsBoard = Region.fromString(props.region).ratingsBoard;
      return (ratingsBoard in props.shopItem.ratingsBoards)
        ? props.shopItem.ratingsBoards[ratingsBoard]
        : props.shopItem.ratingsBoards[defaultRatingsBoard];
    }
  }

  getStore () {
    return shopStore;
  }

  getStateFromStore () {
    return shopStore.getFullProductState(this.props.shopItem.identifier);
  }

  shouldComponentUpdate (nextProps, nextState) {
    return (!deepEquals(this.props, nextProps) || !deepEquals(this.state, nextState));
  }

  onSale () {
    return (this.state
            && this.state.priceData
            && 'salePrice' in this.state.priceData
            && this.state.priceData.normalPrice.amount > this.state.priceData.salePrice.amount);
  }

  render () {
    let {css, shopItem, service, showMoreInfoButton, moreInfoButtonLabel, layoutType} = this.props;
    let buttonsRow = <div>
      <BuyButton
        css={css}
        isDisabled={(shopItem.disable || (this.state && this.state.disable))}
        identifier={shopItem.identifier}
        isPreorder={shopItem.preorder}
        purchaseIdentifier={shopItem.purchaseIdentifier}
        productData={this.state.productData}
        service={service}
        purchaseModalContent={this.state.purchaseModalContent}
        ratingsBoard={this.ratingsBoard(this.props)} />
      <MoreInfoButton
        css={css}
        identifier={shopItem.identifier}
        showMoreInfoButton={showMoreInfoButton}
        moreInfoButtonLabel={moreInfoButtonLabel}
        onClick={() => service.getMoreInfoHref(shopItem)} />
    </div>;

    return (<div className={`${css['shop-product']} ${(layoutType === ShopItem.layoutTypes.CTA_OUTSIDE) && css.CTAOutside} ${(typeof shopItem.backgroundPath !== 'undefined' && shopItem.backgroundPath !== '')
      ? css.FullWidth
      : ''}`}>
      {(layoutType === ShopItem.layoutTypes.CTA_OUTSIDE)
        && <div className={css.details}>
          <ShopItemTitle
            css={css}
            title={shopItem.title}
            subtitle={shopItem.subtitle} />
        </div>}
      <div className={css.poster}>
        <ShopItemBackgroundImage
          css={css}
          backgroundPath={shopItem.backgroundPath}
          squareBackgroundPath={shopItem.squareBackgroundPath} />
        <ShopItemStatus
          css={css}
          showStatusBar={shopItem.showStatusBar}
          status={shopItem.status}
          isDisabled={(this.state && this.state.disable)}
          priceData={this.state.priceData}
          isOnSale={this.onSale()} />
        {(layoutType === ShopItem.layoutTypes.CTA_INSIDE) && buttonsRow}
      </div>
      <ShopItemFootnote
        css={css}
        footnote={shopItem.footnote ? shopItem.footnote : ''} />
      <div className={`${css.details} ${(layoutType === ShopItem.layoutTypes.CTA_OUTSIDE) && css.WithPrice}`}>
        {(layoutType === ShopItem.layoutTypes.CTA_INSIDE)
         && <ShopItemTitle
           css={css}
           title={shopItem.title}
           subtitle={shopItem.subtitle} />}
      </div>
      {(layoutType === ShopItem.layoutTypes.CTA_OUTSIDE) && buttonsRow}
    </div>);
  }
}

ShopItem.layoutTypes = {
  CTA_INSIDE: 0,
  CTA_OUTSIDE: 1,
};

ShopItem.contextTypes = {
  buildContext: PropTypes.instanceOf(BuildContext),
};

ShopItem.propTypes = {
  css: PropTypes.object,
  showMoreInfoButton: PropTypes.bool,
  layoutType: PropTypes.oneOf(Object.values(ShopItem.layoutTypes)),
  open: PropTypes.bool,
  productData: PropTypes.shape({
    priceData: PropTypes.object,
    purchaseModalContent: PropTypes.node,
  }),
  purchaseModalSize: PropTypes.shape({
    height: PropTypes.number,
    width: PropTypes.number,
  }),
  service: PropTypes.instanceOf(ShopProvider),
  shopItem: PropTypes.shape({
    backgroundPath: PropTypes.string,
    body: PropTypes.string,
    disable: PropTypes.bool,
    esrbIconPath: PropTypes.string,
    identifier: PropTypes.string,
    modalBackgroundPath: PropTypes.string,
    modalTitle: PropTypes.string,
    footnote: PropTypes.string,
    path: PropTypes.string,
    preorder: PropTypes.bool,
    priority: PropTypes.number,
    purchaseIdentifier: PropTypes.string,
    purchaseModalHeight: PropTypes.string,
    ratingReasons: PropTypes.arrayOf(PropTypes.object),
    row: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    shopItemIndex: PropTypes.number,
    slug: PropTypes.string,
    status: PropTypes.string,
    subtitle: PropTypes.string,
    title: PropTypes.string,
    vendor: PropTypes.string,
  }),
  userCountry: PropTypes.string,
};

ShopItem.defaultProps = {
  layoutType: ShopItem.layoutTypes.CTA_INSIDE,
  open: false,
  showMoreInfoButton: true,
  showStatusBar: true,
};



// WEBPACK FOOTER //
// ./lib/rlink-shop/components/ShopItem.jsx